import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LsButtonComponent, LsInputTextComponent, LsMessageComponent, LsModalComponent } from '@axess/ng-limestone';
import { TranslateModule } from '@ngx-translate/core';
import { HideTranslationPipe } from '@shared/pipes/hide-translation/hide-translation.pipe';
import { SafeHtmlPipe } from '@shared/pipes/safe-html/safe-html.pipe';
import { NumbersOnlyInput } from '@ui/directives/numbers-only-input';
import { OverlayPortal } from '@ui/directives/overlay-portal';
import { WYSIWYGPipe } from '@ui/pipes/wysiwyg.pipe';
import { VerifyPhoneModalFacade } from './data-access/services/verify-phone-modal-facade';

@Component({
  selector: 'app-verify-phone-modal',
  templateUrl: './verify-phone-modal.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    HideTranslationPipe,
    WYSIWYGPipe,
    SafeHtmlPipe,
    NumbersOnlyInput,
    OverlayPortal,
    LsModalComponent,
    LsInputTextComponent,
    LsButtonComponent,
    LsMessageComponent
  ],
  providers: [VerifyPhoneModalFacade]
})
export class VerifyPhoneModal {
  readonly #verifyPhoneModalFacade = inject(VerifyPhoneModalFacade);

  protected readonly verifyPhoneModalState = this.#verifyPhoneModalFacade.init().state;

  protected onVerifyPhone($event: MouseEvent) {
    $event.stopPropagation();

    this.#verifyPhoneModalFacade.verifyPhone();
  }

  protected onVerifyPhoneResend($event: MouseEvent) {
    $event.stopPropagation();

    this.#verifyPhoneModalFacade.verifyPhoneResend();
  }

  protected onCloseModalWindow() {
    this.#verifyPhoneModalFacade.setIsVerifyPhoneModalOpen(false);
  }
}
